import { render, staticRenderFns } from "./product-resource-resource-item-3-find-customers-to-sell-to.vue?vue&type=template&id=0ca823e6&scoped=true&"
import script from "./product-resource-resource-item-3-find-customers-to-sell-to.vue?vue&type=script&lang=ts&"
export * from "./product-resource-resource-item-3-find-customers-to-sell-to.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca823e6",
  null
  
)

export default component.exports